import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (content: string) => void;
  loading?: boolean;
};

const FeedbackDialog: React.FC<Props> = ({ open, onClose, onSubmit, loading = false }) => {
  const [content, setContent] = React.useState('');

  const isValid = content.trim().length > 0;

  const handleSubmit = () => {
    if (!isValid) return;
    onSubmit(content.trim());
    setContent('');
  };

  const handleClose = () => {
    setContent('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        elevation: 0,
        sx: { borderRadius: 3, border: 1, borderColor: 'divider' },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1,
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          フィードバック
        </Typography>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="内容"
            required
            fullWidth
            multiline
            minRows={5}
            maxRows={10}
            value={content}
            onChange={(e) => setContent(e.target.value.slice(0, 3000))}
            inputProps={{ maxLength: 3000 }}
            helperText={`${content.length}/3000`}
            size="small"
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={!isValid || loading}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: 'none',
                '&:hover': { boxShadow: 'none' },
              }}
            >
              送信
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackDialog;
